import { useState } from 'react';
import { InputHighlightOverlay } from 'modules/ai/copyAssist/components/InputHighlightOverlay';

interface SuggestionHighlightProps {
  value: string;
  /* ref for the element to target */
  targetRef?: React.RefObject<HTMLDivElement> | null;
}

export const SuggestionHighlight = ({ targetRef, value }: SuggestionHighlightProps) => {
  const [highlight, setHighlight] = useState(true);

  if (!highlight) return null;

  return (
    <InputHighlightOverlay
      value={value}
      targetRef={targetRef}
      onHighlightClick={() => setHighlight(false)}
      isAnimated={false}
    />
  );
};
